module.exports = __webpack_public_path__ + "static/media/reblozyl-graphic-3.b5423d1c.png";